import React, { useEffect } from 'react';
import { WorkItemImageDetails } from './WorkItemImageDetails';
import Header from './Header';
import WorkItemNotification from './WorkItemNotification';
import NotificationManager from './NotificationManager/NotificationManager';
import { useSelector } from 'react-redux';
import './styles.css';
import { useAppDispatch } from '../../store/configureStore';
import { initializeColumbia } from '../../store/slices/columbiaSlice';

export default function WorkItemComponent() {
  const { workItemSelectedImages } = useSelector((state) => state.images);

  useEffect(() => {
    const dispatch = useAppDispatch();
    dispatch(initializeColumbia());
  }, [workItemSelectedImages]);

  return (
    <div className="work-item">
      <div className="work-item__mobile">
        <NotificationManager />
      </div>
      <div className="work-item__desktop">
        <Header />
        <div className="work-item__content">
          <WorkItemNotification display={!Object.keys(workItemSelectedImages).length} />
          {workItemSelectedImages &&
            Object.keys(workItemSelectedImages).map((image, index) => (
              <WorkItemImageDetails key={index} image={workItemSelectedImages[image]} />
            ))}
        </div>
      </div>
    </div>
  );
}
